"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderOriginationCloseButton = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var Icon_1 = require("../Icon");
var HeaderOriginationCloseButton = function (props) {
    var _a = props.closeText, closeText = _a === void 0 ? 'Close' : _a, restprops = __rest(props, ["closeText"]) // tslint:disable-line
    ;
    var closeIconContent = (React.createElement(React.Fragment, null,
        React.createElement("span", { className: "close-label" }, closeText),
        React.createElement(Icon_1.Icon, { type: "svginline", symbol: "controlClose24", iconClassName: "close-icon" })));
    var attributes = __assign(__assign({}, restprops), { className: 'icon-wrapper headerorigination-close' });
    if (props.href) {
        attributes.href = props.href;
        return (React.createElement("a", __assign({}, attributes), closeIconContent));
    }
    else if (typeof props.onClick !== 'undefined') {
        attributes.onClick = props.onClick;
        attributes.type = 'button';
        return (React.createElement("button", __assign({}, attributes), closeIconContent));
    }
    return null;
};
exports.HeaderOriginationCloseButton = HeaderOriginationCloseButton;
exports.HeaderOriginationCloseButton.propTypes = {
    closeText: PropTypes.string,
    href: PropTypes.string,
    onClick: PropTypes.func,
};
